import { Box } from '@mui/material';
import { DealFrom } from 'components/featured/Deals/components/DealForm';
import { DealType } from 'model/deals.model';
import { useLocation } from 'react-router-dom';

const DealNew = () => {
  const location = useLocation();
  let type = location.state.type;

  return (
    <Box sx={{ height: 'calc(100vh - 200px)' }}>
      <DealFrom pipelineType={type as DealType} isEdit={false} />
    </Box>
  );
};

export default DealNew;
